import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { store as storeApi } from '@teem/constants/api';

@Injectable({
	providedIn: 'root'
})
export class AnalticsService {

	constructor(
		protected httpClient: HttpClient
	) { }

	public get(params: any) {
		return this.httpClient.post(`${storeApi.getAnalytics}`,params);
	}
}
